// extracted by css-extract-rspack-plugin
export default {"activityRow":"ActivityRows-module__activityRow__tvTYP"};